<div class="loading" [class.loading-hidden]="!show"><div class="loading-indicator"></div></div>